import { useQuery } from '@tanstack/react-query';

import { api, unwrap } from './api/client.js';

/** All sites of the account with their summary (overview, site header, side panel). */
export function useSites() {
  return useQuery({
    queryKey: ['sites'],
    queryFn: () => unwrap(api.GET('/sites')),
    refetchInterval: 60_000,
  });
}
